<ng-container class="spinner-container">
	<div fxLayout="column" style="background: linear-gradient(#242424,#141414);;padding:16px;">
		<!-- <div style="background-color: #242424;" fxFlex.sm="480px" fxFlex.md="680px" fxFlex.lg="1094px" fxFlex.lt-md="100%" fxLayout="column"> -->
		<!-- <div style="background-color: #242424;" fxFlex="1094px" fxFlex.lt-sm="100%"> -->
		<div style="background-color:#242424;">
			<div style="padding:16px; color: #ffffff;">
				<div data-idtest="payment-t-5Id" class="card-title" translate>お支払い情報</div>
			</div>
		</div>
		<mat-card class="card-background" style="margin:20px;">
			<mat-card-content>
				<div *ngFor="let account of pay_accounts">
					<span fxLayoutAlign="center" style="font-weight:900;font-size: 20px;margin: 12px;line-height:32px;"><span translate>当アカウントは、</span>{{account.content.nickname}}<span translate>様により既にご契約いただいております。</span></span>
				</div>
				<div *ngIf="pay_accounts.length === 0">
					<div fxLayout="column" fxLayoutAlign="space-between">
						<div *ngIf="!isCustomer" class="set-customer" fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="space-between center" fxLayoutAlign.lt-sm="space-between start"> <!-- 住所未登録  -->
							<div data-idtest="payment-t-8Yf" style="margin: 10px 10px 10px 0;line-height: 1.3;" translate>送付先の氏名・電話番号・住所をご登録後、クレジットカード情報をご登録ください。</div>
							<button (click)="createCustomerDialog()" color="primary" mat-raised-button id="mat-regist-button-2">
								<span data-idtest="payment-t-9Br" translate>住所登録</span>
							</button>
						</div>
					</div>
					<div fxLayout="column" fxLayoutAlign="space-between">
						<div *ngIf="isCustomer" class="set-customer" fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="space-between center" fxLayoutAlign.lt-sm="space-between start"> <!-- 住所登録済  -->
							<div data-idtest="payment-t-2Wn" style="margin: 10px 10px 10px 0;line-height: 1.3;" translate>氏名・電話番号・住所の確認・変更</div>
							<div fxLayout="row wrap" fxLayout.lt-sm="column">
								<button data-idtest="payment-b-4Ey" style="margin:0 8px;" (click)="updateCustomerDialog()" color="primary" mat-raised-button id="update-customer">
									<span data-idtest="payment-t-9Fj" translate>確認・変更</span>
								</button>
							</div>
						</div>
					</div>
					<div *ngIf="auth | aigauthis: 'user'" fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="space-between center" fxLayoutAlign.lt-sm="space-between start" style="margin: 30px 0">
						<div data-idtest="payment-t-3Rz" style="margin: 10px 10px 10px 0;line-height: 1.3;" translate>クレジットカードの登録</div>
						<span fxLayout="column wrap" fxLayoutAlign="end end">
						<button data-idtest="payment-b-3Cl" style="width:120px" (click)="createCardDialog()" [disabled]="!isCustomer" color="primary" mat-raised-button>
							<span data-idtest="payment-t-1Ry" translate>登録・追加</span>
						</button>
						<div *ngIf="!isCustomer">
							<p class="color:red;"><span data-idtest="payment-t-4Mp" translate>※氏名・電話番号・住所の確認・変更の入力をしてください</span></p>
						</div>
					</span>
					</div>
					<div *ngIf="isCustomer" class="set-customer" fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="space-between center" fxLayoutAlign.lt-sm="space-between start"> <!-- 住所登録済  -->
						<div data-idtest="payment-t-0Gu" style="margin: 10px 10px 10px 0;line-height: 1.3;" translate>クレジットカード情報</div>
						<div fxLayout="column" fxLayoutAlign="end end">
							<mat-radio-group (change)="updateDefault($event)" *ngFor="let card of results" class="radio-group" name="sortCategory">
								<mat-radio-button [checked]="card.is_default" [ngStyle]="defaultCard(card.is_default)" [value]="card.id" class="radio-button">
									<div fxLayout="row wrap" fxLayoutAlign="end center">
										<img [src]="'/icons/'+  card.brand + '.png'" style="width: 50px;" alt="">
										<div style="padding-left: 12px;width: 160px;text-align: right;">{{card.display_no}}</div>
										<div style="padding-left: 12px;width: 60px;text-align: right;">{{card.exp_month}}/{{card.exp_year}}</div>

										<button data-idtest="payment-b-2Vw" (click)="onDeleteSource(card.id)" mat-icon-button id="mat-delete-button">
											<mat-icon color="warn">delete_sweep</mat-icon>
										</button>

									</div>
								</mat-radio-button>
							</mat-radio-group>
						</div>
					</div>
					<div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="space-between center" fxLayoutAlign.lt-sm="space-between start" style="margin: 30px 0">
						<div data-idtest="payment-t-1Gz" style="margin: 10px 10px 10px 0;line-height: 1.3;" translate>プラン入会・退会</div>
						<div *ngIf="isCustomer">    <!-- 住所登録済  -->
							<div *ngIf="hasPaymentMethod"> <!-- カード登録済  -->
								<div *ngIf="!isSubscribe"> <!-- 未入会  -->
									<button (click)="subscribe()" color="warn" [disabled]="isProgress" mat-raised-button id="mat-subscribe-button"><span data-idtest="payment-t-4Rn" translate>入会</span></button>
								</div>
								<div *ngIf="isSubscribe"> <!-- 入会済  -->
									<button (click)="unSubscribe()" color="warn" [disabled]="isProgress" mat-raised-button id="mat-unsubscribe-button"><span data-idtest="payment-t-4Lu" translate>退会</span></button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
		<mat-spinner *ngIf="isProgress" class="spinner"></mat-spinner>
	</div>
</ng-container>
